var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeHide = function SvgEyeHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    clipPath: "url(#eye-hide_svg__clip0_3390_5470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.373 13.183a2.06 2.06 0 0 1 0-2.366C2.946 8.59 6.819 4 12 4c5.18 0 9.054 4.59 10.627 6.817a2.06 2.06 0 0 1 0 2.366C21.054 15.41 17.18 20 12 20s-9.054-4.59-10.627-6.817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 22 22 2"
  }))));
};
export default SvgEyeHide;